// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"b4fc66ae","213":"7bfcdc70","401":"7edfd0a1","453":"7c6eaf90","684":"81c15e99","724":"276ca6e9","900":"41e6754e","939":"1daaa87f"}[chunkId] + ".chunk.js";
};